let randomEventsData = [
	// Minor
	{'name': 'superstarNotAvailable', 'category': 'minor', 'repeatable': true},
	{'name': 'superstarNotAvailable', 'category': 'minor', 'repeatable': true},
	{'name': 'superstarNotAvailable', 'category': 'minor', 'repeatable': true},
	{'name': 'mainstreamCoverage', 'category': 'minor', 'repeatable': false},
	{'name': 'ownerControversy', 'category': 'minor', 'repeatable': false},
	{'name': 'negativeSuperstarCoverage', 'category': 'minor', 'repeatable': true},
	{'name': 'moraleBoost', 'category': 'minor', 'repeatable': true},
	{'name': 'gimmickInterview', 'category': 'minor', 'repeatable': true},
	{'name': 'goodTrainingSession', 'category': 'minor', 'repeatable': true},
	{'name': 'neglectedTraining', 'category': 'minor', 'repeatable': true},
	{'name': 'hairChange', 'category': 'minor', 'repeatable': false},
	{'name': 'gimmickMatchBoost', 'category': 'minor', 'repeatable': false},
	{'name': 'feudIgnored', 'category': 'minor', 'repeatable': true},
	{'name': 'feudBoosted', 'category': 'minor', 'repeatable': true},
	{'name': 'cultFollowing', 'category': 'minor', 'repeatable': false},
	{'name': 'wrestlerCourt', 'category': 'minor', 'repeatable': false},
	{'name': 'factionBoosted', 'category': 'minor', 'repeatable': false},
	{'name': 'factionIgnored', 'category': 'minor', 'repeatable': false},
	// Major
	{'name': 'fluBug', 'category': 'major', 'repeatable': false},
	{'name': 'flightsCancelled', 'category': 'major', 'repeatable': false},
	{'name': 'backstageUnrest', 'category': 'major', 'repeatable': false},
	{'name': 'planeRideSuspensions', 'category': 'major', 'repeatable': false},
	{'name': 'stormAffectsShow', 'category': 'major', 'repeatable': false},
	{'name': 'showAppearances', 'category': 'major', 'repeatable': false},
	{'name': 'backstageFight', 'category': 'major', 'repeatable': true},
	{'name': 'drugAbuse', 'category': 'major', 'repeatable': true},
	{'name': 'superstarBreak', 'category': 'major', 'repeatable': true},
	{'name': 'championshipStolen', 'category': 'major', 'repeatable': false},
	{'name': 'conservativeGovernmentShow', 'category': 'major', 'repeatable': false},
	{'name': 'drugScandal', 'category': 'major', 'repeatable': false},
	{'name': 'backstageBrawl', 'category': 'major', 'repeatable': false}
];

const superstarUnavailableReasons = [
	{
		"name": "Missed Flight",
		"content": "I missed my flight! I'll try my best to get another but I don't think I'll be able to make it to " +
			"the show."
	},
	{
		"name": "Car Accident",
		"content": "I had a small car accident on my way to the show. I'm doing fine but I won't be able to make it to" +
			" the event."
	},
	{
		"name": "Lost Ticket",
		"content": "I lost my ticket and couldn't get a new one in time, so I can't show up for the upcoming event. Sorry!"
	},
	{
		"name": "Car Breakdown",
		"content": "My car broke down on the way to the arena. Unfortunately, I won't be able to make it."
	},
	{
		"name": "Home Accident",
		"content": "I had a minor accident while driving around on my motorbike. I know, it was quite stupid. I'm doing " +
			"better but I can't wrestle this show."
	},
	{"name": "Illness", "content": "I've come down with a bad case of the flu. I don't think I can wrestle right now."},
	{
		"name": "Lost Passport",
		"content": "I lost my passport.. can you believe that? Needless to say I can't make it to the show."
	},
	{
		"name": "Family Emergency",
		"content": "A family emergency came up today so I won't be able to come to the next event. I'll see you after."
	},
	{
		"name": "Can't Make It",
		"content": "Due to some personal reasons, I cannot make it to the upcoming event. You'll have to do without me."
	}
]

export {randomEventsData, superstarUnavailableReasons}